import { TooltipFormatterContextObject } from 'highcharts'
import React from 'react'
import * as Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { renderToStaticMarkup } from 'react-dom/server'
import { Mode, StyledScreenReadersOnly, TTrendDirection } from '~common'
import { LinkThemeProvider } from '~common/theme'
import { StyledHighchartsTooltipDiv } from '~components/ui/organisms/charts/styles'
import { Timeframe, TimeframeRange } from '../../components/timeframe'
import { StyledOnTopicChart } from './styles'
import { useOnTopicChartOptions } from './use-on-topic-chart-options'

export interface OnTopicChartProps {
  setYearsRange: (timeframeRange: TimeframeRange) => void
  selectedYearsRange: TimeframeRange
  yearRanges: TimeframeRange[]
  categories: (number | string)[]
  regressionLineData: number[]
  onTopicRegressionLineDirection: TTrendDirection
  onTopicData: {
    y: number
  }[]
  themeMode: Mode
  themeBrand: 'pharmaspectra' | 'iqvia'
}

export const OnTopicChart = ({
  setYearsRange,
  selectedYearsRange,
  yearRanges,
  onTopicRegressionLineDirection,
  categories,
  onTopicData,
  regressionLineData,
  themeMode,
  themeBrand,
}: OnTopicChartProps): JSX.Element => {
  const toolTipFormatter = (context: TooltipFormatterContextObject) => {
    const tooltipElement = (
      <LinkThemeProvider mode={themeMode} brand={themeBrand}>
        <StyledHighchartsTooltipDiv>
          <div className="highcharts-tooltip">
            <div className="key-value-wrapper">
              <span className="value">{context.key}</span>
            </div>
            <div className="key-value-wrapper">
              <span className="key">Count</span> <span className="value">{context.y}</span>
            </div>
          </div>
        </StyledHighchartsTooltipDiv>
      </LinkThemeProvider>
    )

    return renderToStaticMarkup(tooltipElement)
  }

  const [options] = useOnTopicChartOptions({
    data: onTopicData,
    categories,
    regressionLineData,
    onTopicRegressionLineDirection,
    toolTipFormatter,
  })

  return (
    <StyledOnTopicChart>
      <Timeframe timeRanges={yearRanges} selectTimeRange={setYearsRange} selectedTimeRange={selectedYearsRange} />
      <HighchartsReact highcharts={Highcharts} options={options} />
      <StyledScreenReadersOnly>On topic column chart</StyledScreenReadersOnly>
    </StyledOnTopicChart>
  )
}
